import { Component, EventEmitter, Output } from '@angular/core';
import { BotService } from '../../../../core/services/bot.service';
import { SpinnerService } from '../../../../core/services/spinner.service';
import { GetBotResponse, PutUpdateBotRequest } from '../../../../models/bot.interface';

@Component({
  selector: 'globot-process-chatbot',
  templateUrl: './process-chatbot.component.html',
  styleUrls: ['./process-chatbot.component.scss'],
})
export class ProcessChatbotComponent {
  @Output() nextEvent = new EventEmitter<void>();
  @Output() backEvent = new EventEmitter<void>();

  bot?: GetBotResponse;

  selectedCardIndex: number = -1;

  contextType?: 'DEFAULT' | 'CLIENT_SERVICE' | 'PROFESSIONAL' | 'INFORMAL';
  temperature: number = 0.1;

  constructor(private readonly botService: BotService, private readonly ss: SpinnerService) {
    if (localStorage.getItem('bot')) {
      this.bot = JSON.parse(localStorage.getItem('bot')!);
    }
  }

  next(): void {
    if (this.selectedCardIndex === -1) {
      return;
    }
    this.setContextType();
    this.nextEvent.emit();
  }
  back(): void {
    this.backEvent.emit();
  }

  setContextType() {
    switch (this.selectedCardIndex) {
      case 1:
        this.contextType = 'CLIENT_SERVICE';
        this.temperature = 0.7;
        break;
      case 2:
        this.contextType = 'PROFESSIONAL';
        this.temperature = 0.5;
        break;
      case 3:
        this.contextType = 'INFORMAL';
        this.temperature = 1.0;
        break;
      default:
        this.contextType = 'DEFAULT';
        this.temperature = 0.5;
        break;
    }
    this.ss.setHttpProgressStatus(true);
    const payload: PutUpdateBotRequest = {
      name: this.bot!.name,
      temperature: this.temperature,
      context_type: this.contextType,
    };
    this.botService.updateBot(payload, this.bot!.id).subscribe({
      next: (_value) => {
        this.botService.getBot(this.bot!.id).subscribe({
          next: (value) => {
            this.bot = value;
            localStorage.setItem('bot', JSON.stringify(value));
            this.ss.setHttpProgressStatus(false);
          },
        });
      },
    });
  }

  selectCard(index: number): void {
    if (this.selectedCardIndex === index) {
      this.selectedCardIndex = -1;
      return;
    }
    this.selectedCardIndex = index;
  }
}
